import '../keyword/keywords_filter_view.js.coffee'

class Monitoring.Views.SocialContents.Filters.SurveyKeywordFilterView extends Monitoring.Views.SocialContents.Filters.KeywordsFilterView

  initialize: (@options = {}) ->
    super(@options)
    @name = @options.name
    @alias = @options.alias
    @survey = @options.survey
    @groups_logic = {
      'first_group_items':    @searchQuery.getSurveyKeywords('primary_keywords_logic', @name, @survey),
      'second_group_items':   @searchQuery.getSurveyKeywords('secondary_keywords_logic', @name, @survey),
      'excluded_group_items': @searchQuery.getSurveyKeywords('excluded_keywords_logic', @name, @survey)
    }
    @possible_tags = {'first_group_items': [], 'second_group_items': [], 'excluded_group_items': []}
    @selected_items = {
      'first_group_items': @withCodeAndName(@searchQuery.getSurveyKeywords('primary_keywords', @name, @survey)),
      'second_group_items': @withCodeAndName(@searchQuery.getSurveyKeywords('secondary_keywords', @name, @survey)),
      'excluded_group_items': @withCodeAndName(@searchQuery.getSurveyKeywords('excluded_keywords', @name, @survey))
    }

  onApply: =>
    @searchQuery.setSurveyKeywords('name', @alias, @name, @survey)
    @searchQuery.setSurveyKeywords('primary_keywords', _.pluck(@firstGroupView.selectedItems, 'code'), @name, @survey)
    @searchQuery.setSurveyKeywords('primary_keywords_logic', @firstGroupView.logic, @name, @survey)

    @searchQuery.setSurveyKeywords('secondary_keywords', _.pluck(@secondGroupView.selectedItems, 'code'), @name, @survey)
    @searchQuery.setSurveyKeywords('secondary_keywords_logic', @secondGroupView.logic, @name, @survey)

    @searchQuery.setSurveyKeywords('excluded_keywords', _.pluck(@excludedGroupView.selectedItems, 'code'), @name, @survey)
    @searchQuery.setSurveyKeywords('excluded_keywords_logic', @excludedGroupView.logic, @name, @survey)

    unless @options.blockChangeEvent
      if @options.forRule
        @trigger('changed:keywords', _.pluck(@firstGroupView.selectedItems, 'code'), _.pluck(@secondGroupView.selectedItems, 'code'), _.pluck(@excludedGroupView.selectedItems, 'code'), @firstGroupView.logic, @secondGroupView.logic, @excludedGroupView.logic)
      else
        @eventAggregator.trigger('searchQueryChanged', @searchQuery)
    @onClose()
